module.exports = __webpack_public_path__ + "img/thumb-wentelteefjes.3588ae17.jpeg";